module.exports = __webpack_public_path__ + "img/phone-call-black.a0a90aa9.svg";